import { Button, Flex, Modal, Row, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import { FormInput, FormInputNumber, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

function EmployeeWelfareModal({
    isModalOpen = false,
    setIsModalOpen = () => { },
    selectedRecord = [],
    updateEmployeeWelfare = () => { }
}) {
    const { t, i18n } = useTranslation();
    const [form] = useForm();

    useEffect(() => {
        if (isModalOpen && selectedRecord) {
            form.setFieldsValue({
                ...selectedRecord,
                maxPerMonth: selectedRecord?.numberOfRights,
                maxPerYear: selectedRecord?.maxPerYear,
            });
        }
    }, [isModalOpen, selectedRecord]);

    return (
        <Modal
            title={<span style={{ color: "#42526D" }}>{t("common.edit")}</span>}
            destroyOnClose
            open={isModalOpen}
            footer={null}
            closable={false}
            maskClosable={false}
        >
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <span style={{ fontSize: "14px", color: "#667085" }}>
                    {i18n.language === "en"
                        ? selectedRecord?.welfareNameEn
                        : selectedRecord?.welfareName}
                </span>

                <FormAntd
                    form={form}
                    onFinish={updateEmployeeWelfare}
                >
                    <FormItem shouldUpdate={(prev, cur) =>
                        null
                    }>
                        {({ getFieldValue, setFieldValue, resetForm }) => {

                            return (
                                <Space size={24} style={{ width: "100%" }} direction="vertical">
                                    <Flex vertical gap={16}>
                                        <FormInputNumber
                                            name="maxPerMonth"
                                            label={t("welfare.label.number_of_right_per_month")}
                                            size="large"
                                            placeholder={t("unlimited")}
                                            controls={false}
                                            precision={0}
                                            parser={(value) => {
                                                if (!value) return null;
                                                return value.replace(/[^\d]/g, "");
                                            }}
                                            formatter={(value) => {
                                                if (value === null || value === undefined || value === "") return "";
                                                return value.toString();
                                            }}
                                        />

                                        <FormInputNumber
                                            name="maxPerYear"
                                            label={t("welfare.label.number_of_right_per_year")}
                                            size="large"
                                            placeholder={t("unlimited")}
                                            controls={false}
                                            // precision={2}
                                            parser={(value) => {
                                                if (!value) return null;
                                                return value.replace(/[^\d]/g, "");
                                            }}
                                            formatter={(value) => {
                                                if (value === null || value === undefined || value === "") return "";
                                                return value.toString();
                                            }}
                                        />
                                    </Flex>
                                    <Row justify={"end"} style={{ gap: "12px" }}>
                                        <Button
                                            size="large"
                                            type="default"
                                            onClick={() => {
                                                form.resetFields();
                                                setIsModalOpen(false);
                                            }}
                                            style={{ color: "#344054", fontWeight: "bold" }}
                                        >
                                            {t("common.cancel")}
                                        </Button>
                                        <Button
                                            htmlType="submit"
                                            type="primary"
                                            style={{ fontWeight: "bold", backgroundColor: "var(--button-color)" }}
                                            size="large"
                                        >
                                            {t("common.submit")}
                                        </Button>
                                    </Row>
                                </Space>
                            )
                        }}
                    </FormItem>
                </FormAntd>
            </Space>
        </Modal >
    )
}

export default EmployeeWelfareModal;